import * as yup from 'yup';
import i18n from 'i18next';

const schema = yup
  .object({
    email: yup.string().required(() => i18n.t('auth.validations.required')),
    phone: yup.string().required(() => i18n.t('auth.validations.required')),
  })
  .required();

export default schema;
